export default __webpack_public_path__ + "static/81489-5ecdd0b6074a03c80e56e5fe7b4fc189.jpg";